import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MessageSquare, UserCheck, Bot, Link2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const CARDS = [
  { key: 'messages_today', label: 'Messages Processed', icon: MessageSquare, type: 'number' },
  { key: 'leads_qualified_today', label: 'Leads Qualified', icon: UserCheck, type: 'number' },
  { key: 'bot_active', label: 'Bot Status', icon: Bot, type: 'status', activeText: 'Active', inactiveText: 'Inactive' },
  { key: 'crm_connected', label: 'CRM Connected', icon: Link2, type: 'status', activeText: 'Connected', inactiveText: 'Not Connected' },
];

export default function StatsPanel() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetchStats();
    const interval = setInterval(fetchStats, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchStats = async () => {
    try {
      const { data } = await axios.get(`${API}/api/stats/today`, { withCredentials: true });
      setStats(data);
    } catch { /* ignore */ }
  };

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="stats-panel">
      {CARDS.map(({ key, label, icon: Icon, type, activeText, inactiveText }) => {
        const value = stats?.[key];
        const isActive = type === 'status' && value === true;
        const isInactive = type === 'status' && value === false;

        return (
          <div
            key={key}
            data-testid={`stat-card-${key}`}
            className="border border-[#27272A] rounded-lg bg-[#1A1A1A] px-4 py-3.5 transition-all duration-200 hover:border-[#7B2FFF]/30"
          >
            <div className="flex items-center gap-2 mb-2">
              <Icon className="w-3.5 h-3.5 text-[#7B2FFF]" />
              <span className="text-xs text-[#71717A] font-medium">{label}</span>
            </div>
            {stats === null ? (
              <div className="h-7 flex items-center">
                <div className="w-4 h-4 border-2 border-[#27272A] border-t-[#7B2FFF] rounded-full animate-spin" />
              </div>
            ) : type === 'number' ? (
              <p className="text-2xl font-bold text-[#EDEDF0] tracking-tight" style={{ fontFamily: "'Unbounded', sans-serif" }}>
                {value ?? 0}
              </p>
            ) : (
              <div className="flex items-center gap-2">
                <div className={`w-2 h-2 rounded-full shrink-0 ${isActive ? 'bg-emerald-400' : 'bg-red-400'}`} />
                <span className={`text-sm font-semibold ${isActive ? 'text-emerald-400' : 'text-red-400'}`}>
                  {isActive ? activeText : isInactive ? inactiveText : '—'}
                </span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
